import React from 'react'
import { Box, Button } from '@mui/material'
import { useRive } from '@rive-app/react-canvas';

const EmptyScreen = (props) => {
    if (props.type === "noData") {
        return (
            <Box className='empty-screen no-data'>
                <div className='empty-screen-icon'>
                    <PricingSeasonsIcon />
                </div>
                <Box className='empty-msg'>{props.msg}</Box>
            </Box>
        )
    }

    const clickHandler = () => {
        if (props.handleConfigureClick) {
            props.handleConfigureClick();
        }
    }

    return (
        <Box
            className="empty-screen"
            sx={{
                height: "60vh", // full height of viewport
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
            }}
        >
            {/* Image */}
            <div className='empty-screen-icon'>
                <PricingSeasonsIcon />
            </div>
            {/* Text */}
            <div>
                <Box className='h3-title' sx={{ mb: 0.5 }}>Set Up a Pricing Season</Box>
                <Box className='p-text' sx={{ mb: 2 }}>Create a Pricing Season to Unlock Rate Recommendations, <br></br> Enable <strong className='p-text-bold'> Auto Rate Push</strong>, and Activate Pricing.</Box>
                <Button className="button" onClick={clickHandler}>Configure Now</Button>
            </div>
        </Box>
    )
}

export default EmptyScreen


function PricingSeasonsIcon() {
    const { rive, RiveComponent } = useRive({
        src: 'assets/rive/pricing_seasons.riv',
        stateMachines: "State Machine 1",
        autoplay: true,
    });

    return (
        <RiveComponent />
    );
}